import type { ModuleDef } from '#src/app/navigation/module';
import { adminModule } from '#src/modules/admin/admin.module';
import { archiveModule } from '#src/modules/archive/archive.module';
import { settingsModule } from '#src/modules/settings/settings.module';
import { teamsModule } from '#src/modules/teams/teams.module';

/**
 * Registro único dos módulos. Navegação lateral, rotas, breadcrumb e Início
 * saem daqui. Para criar um módulo: `src/modules/<nome>/<nome>.module.ts`
 * com as páginas, e uma linha nesta lista.
 */
export const MODULES: readonly ModuleDef[] = [
  archiveModule,
  adminModule,
  teamsModule,
  settingsModule,
];
